/*
 #*===================================================================
 #*
 #* Licensed Materials - Property of Zuum Transportation Inc.
 #*
 #* Copyright Zuum 2015-2021. All Rights Reserved.
 #*
 #*===================================================================
 */

import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { ApiResponse } from '@core/models';
import { ApiService } from '@core/services';
import { Token } from '@stripe/stripe-js';

@Injectable()
export class StripeSAService {
  constructor(private http: HttpClient, private apiService: ApiService) {}

  getCardFromTokenId(tokenId: string): Observable<ApiResponse<Token>> {
    return this.http
      .get<ApiResponse>(`${this.apiService.superAdminApi}/stripe/card/token/${tokenId}`)
      .pipe(catchError((error: HttpErrorResponse) => throwError(error)));
  }
}
